import { v4 as uuid } from 'uuid';

export default function pollOauthWindow (oauthWindow) {
    const appStore = this;
    clearTimeout(appStore.widgetPollWindowTO);
    const polledId = uuid();
    appStore.polledId = polledId; // this is to prevent previous calls to pollOauthWindow from polling, because the polling is renew
    const subscriberStore = this.env.subscriberStore;
    appStore.oauthWindow = oauthWindow;
    const sessionId = appStore.oauthSessionId;

    function poll () {
        if (oauthWindow && oauthWindow.closed && appStore.polledId === polledId) {
            // finalaize oauth session calls
            subscriberStore.oauthSession({ sessionId });
        } else {
            if (appStore.polledId === polledId) {
                appStore.widgetPollWindowTO = setTimeout(poll, 1000);
            }
        }
    }
    setTimeout(poll, 500);
}

   